import { makeNPageIdStr } from "../common/util/functions";
let _pagefault_manager_instance = null;
export default class PageFaultManager {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {
        this._faultCount = {};
        this.onPageFault = (sobp) => {
            const pageIdStr = makeNPageIdStr(sobp);
            if (!this._faultCount[pageIdStr])
                this._faultCount[pageIdStr] = 0;
            this._faultCount[pageIdStr]++;
            return this._faultCount[pageIdStr];
        };
    }
    static getInstance() {
        if (!_pagefault_manager_instance) {
            _pagefault_manager_instance = new PageFaultManager();
        }
        return _pagefault_manager_instance;
    }
}
PageFaultManager.deafultPageFaultMax = 2;
//# sourceMappingURL=PageFaultManager.js.map